import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Avatar,
} from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import PeopleIcon from '@mui/icons-material/People';
import WcIcon from '@mui/icons-material/Wc';
import SchoolIcon from '@mui/icons-material/School';
import BusinessIcon from '@mui/icons-material/Business';
import ForestIcon from '@mui/icons-material/Forest';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ComputerIcon from '@mui/icons-material/Computer';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import './About.css';

// Placeholder Images
const leaders = [
  {
    name: 'श्री.संतोष ठोंबरे',
    position: 'प्रशासक ',
    image: '/leader.jpg',
    // description: 'ग्रामपंचायत प्रमुख, ग्रामविकास आणि शाश्वततेसाठी काम करणारे.',
  },
  {
    name: 'श्रीमती. प्रतिभा वानखेडकर',
    position: 'ग्राम विकास अधिकारी ',
    image: '/women.jpg',
    //description: 'स्थानिक लोकांसाठी योजनांची अंमलबजावणी सुनिश्चित करणारे.',
  },
  {
    name: 'श्री. राजेश शिंदे',
    position: 'पोलीस अधिकारी',
    image: '/police.jpg',
    description: 'गावातील कायदा आणि सुव्यवस्था राखण्यास कटिबद्ध.',
  },
];

const objectives = [
  { title: 'संपूर्ण विकास', icon: <BusinessIcon style={{ color: '#1E88E5' }} /> },
  { title: 'आरोग्य सेवा', icon: <LocalHospitalIcon style={{ color: '#D32F2F' }} /> },
  { title: 'शिक्षण सुधारणा', icon: <SchoolIcon style={{ color: '#FFC107' }} /> },
  { title: 'डिजिटल परिवर्तन', icon: <ComputerIcon style={{ color: '#7B1FA2' }} /> },
  { title: 'पर्यावरण संरक्षण', icon: <ForestIcon style={{ color: '#388E3C' }} /> },
  { title: 'मूलभूत  सुविधा', icon: <PlaceIcon style={{ color: '#F57C00' }} /> },
];

const statistics = [
  { title: 'लोकसंख्या', value: '3103+', icon: <PeopleIcon style={{ color: '#2196F3' }} /> },
  { title: 'लिंग गुणोत्तर', value: '940 महिलांमागे 1000 पुरुष', icon: <WcIcon style={{ color: '#E91E63' }} /> },
  { title: 'साक्षरता दर', value: '85%', icon: <SchoolIcon style={{ color: '#4CAF50' }} /> },
];

const About = () => {
  return (
    <Container sx={{ py: 8 }}>
      {/* About Section */}
      <Typography variant="h3" component="h1" className="about-heading" sx={{ mb: 3 }}>
      किरकसाल  ग्रामपंचायत बद्दल
      </Typography>
      <Typography variant="body1" paragraph align="center">
      किरकसाल  ग्रामपंचायत स्थानिक समुदायाच्या सेवा आणि ग्रामीण विकासास समर्पित आहे. पारदर्शक प्रशासन आणि सक्रिय समुदाय सहभागाद्वारे टिकाऊ आणि समृद्ध गाव निर्माण करणे हे आमचे ध्येय आहे.
      </Typography>

      {/* Leaders Section */}
      <Box sx={{ mt: 6 }}>
        <Typography variant="h4" component="h2" className="section-heading"  sx={{ mb: 4 }}>
          आमचे  प्रशासक 
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {leaders.map((leader, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card className="leader-card">
                <Avatar src={leader.image} alt={leader.name} className="leader-avatar" />
                <CardContent>
                  <Typography variant="h5" align="center">
                    {leader.name}
                  </Typography>
                  <Typography variant="subtitle1" align="center" color="text.secondary">
                    {leader.position}
                  </Typography>
                  {/* <Typography variant="body2" align="center">
                    {leader.description}
                  </Typography> */}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Key Objectives Section */}
      <Box sx={{ mt: 8 }}>
        <Typography variant="h4" component="h2" className="section-heading"  sx={{ mb:4 }}>
          मुख्य उद्दीष्टे
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {objectives.map((obj, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card className="objective-card">
                <CardContent>
                  <Box className="icon-container">{obj.icon}</Box>
                  <Typography variant="h6" align="center">
                    {obj.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Village Map & Info */}
      <Box sx={{ mt: 8, textAlign: 'center' }}>
        <Typography variant="h4" component="h2" className="section-heading" sx={{ mb:4 }}>
          गावाचा नकाशा आणि माहिती
        </Typography>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <img src="/manmap.jpg" alt="Village Map" className="village-map" />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="body1" paragraph>
            किरकसाल  हे एक प्रगतशील गाव असून येथे शिक्षण, आरोग्य सेवा आणि पर्यावरण सुधारणा यांवर भर दिला जातो. प्रशासनाने विविध उपक्रम राबवून ग्रामविकास साधला आहे.
            </Typography>
            <Typography variant="body1" paragraph>
              <LocationOnIcon style={{ color: '#E53935' }} /> गावाचा पत्ता: किरकसाल ग्रामपंचायत, जिल्हा सातारा  
          , महाराष्ट्र
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Village Statistics */}
      <Box sx={{ mt: 8 }}>
        <Typography variant="h4" component="h2" className="section-heading"sx={{ mb:4 }}>
          गावाची सांख्यिकी माहिती
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {statistics.map((stat, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card className="stat-card">
                <CardContent>
                  <Box className="icon-container">{stat.icon}</Box>
                  <Typography variant="h6" align="center">
                    {stat.title}
                  </Typography>
                  <Typography variant="h5" align="center" className="stat-value">
                    {stat.value}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default About;
